/**
 * Build a deep link to the Client Service Needs page focused on a specific need.
 * Shared by the Work Tasks inbox ("View service need") and the Provider Team
 * ("Open Service Need") so the URL contract stays in one place.
 */
export function serviceNeedInboxPath(tenantPath, { csNeedId, clientId, referralId }) {
  const q = new URLSearchParams();
  if (csNeedId) q.set('needId', String(csNeedId));
  if (clientId) q.set('clientId', String(clientId));
  if (referralId) q.set('referralId', String(referralId));
  const qs = q.toString();
  return `${tenantPath('/lists/client-services')}${qs ? `?${qs}` : ''}`;
}
